<template>
  <div
    id="timeline"
    class="timeline-section"
  >
    <div class="container">
      <h2
        class="banner-text"
        v-html="section.title"
      />
      <div class="timeline">
        <div
          v-for="event of section.events"
          :key="event.date"
          class="event"
        >
          <div
            class="date"
            v-text="event.date"
          />
          <div
            class="text"
            v-text="event.text"
          />
        </div>
        <div class="timeline-label desktop">
          {{ section.year }} Timeline
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stripBlockTags from '@/utils/strip-block-tags';

export default {
  name: 'BannerLikeSection',

  props: {
    section: { type: Object, required: true }
  },

  methods: {
    stripBlockTags
  }
};
</script>

<style lang="scss" scoped>
.timeline-section {
  padding: 0;

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media screen and (min-width: $breakpoint-md) {
    padding: 0;
  }

  h2::v-deep {
    font-size: 48px;
    line-height: 48px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    margin: 0;
    margin-bottom: 30px !important;

    @media screen and (min-width: $breakpoint-md) {
      font-size: 80px;
      line-height: 80px;
      margin-bottom: 0 !important;
    }

    strong {
      color: $thd-orange;
    }
  }

  hr {
    width: 60px;
    color: $thd-tan;
    margin: 0;
  }

  .timeline {
    position: relative;
    padding: 64px 40px 64px 0;
    max-width: 450px;
    width: 100%;

    @media screen and (min-width: $breakpoint-md) {
      display: flex;
      justify-content: space-evenly;
      padding: 64px 40px;
      max-width: 1036px;
    }

    &::before {
      content: '';
      position: absolute;
      inset: 0 0 0 37.4px;
      border: 4.6px dotted $thd-black;
      border-radius: 32px;

      @media screen and (min-width: $breakpoint-md) {
        left: 0;
        top: 142px;
      }
    }

    .event {
      display: flex;
      position: relative;

      @media screen and (min-width: $breakpoint-md) {
        flex-direction: column;
        flex: 0;
      }

      &:not(:last-child) {
        margin-bottom: 40px;
      }

      .date {
        color: $thd-orange;
        border: 6px solid $thd-orange;
        border-radius: 40px;
        height: 68px;
        width: 68px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        flex-shrink: 0;
        font-size: 16px;
        line-height: 16px;
        font-stretch: condensed;
        font-weight: 700;
        background: $thd-white;
        position: relative;

        @media screen and (min-width: $breakpoint-md) {
          height: 110px;
          width: 110px;
          border-radius: 90px;
          border-width: 25px;
          font-size: 26px;
          line-height: 26px;

          &::after {
            content: '';
            background-color: $thd-orange;
            clip-path: polygon(0 0, 100% 0, 50% 100%);
            height: 40px;
            width: 106px;
            position: absolute;
            bottom: -45px;
          }
        }

        &::before {
          content: '';
          background-color: $thd-black;
          clip-path: polygon(0 0, 100% 0, 50% 100%);
          height: 10px;
          width: 20px;
          position: absolute;
          top: -30px;

          @media screen and (min-width: $breakpoint-md) {
            height: 20px;
            width: 10px;
            clip-path: polygon(0 0, 0 100%, 100% 50%);
            top: unset;
            left: -40px;
          }
        }
      }

      &:last-child .date::after {
        content: '';
        background-color: $thd-warm-gray;
        clip-path: polygon(0 0, 100% 0, 50% 100%);
        width: 20px;
        height: 10px;
        position: absolute;
        bottom: -30px;

        @media screen and (min-width: $breakpoint-md) {
          content: '';
          background-color: $thd-orange;
          clip-path: polygon(0 0, 100% 0, 50% 100%);
          height: 40px;
          width: 106px;
          position: absolute;
          bottom: -45px;
        }
      }

      .text {
        font-size: 18px;
        line-height: 24px;
        display: flex;
        align-items: center;
        padding-left: 20px;

        @media screen and (min-width: $breakpoint-md) {
          padding: 20px 0 0;
          text-align: center;
          justify-content: center;
        }
      }
    }

    .timeline-label {
      font-size: 24px;
      line-height: 24px;
      font-stretch: condensed;
      font-weight: 700;
      color: $thd-white;
      background: $thd-black;
      padding: 12px 146px;
      position: absolute;
      bottom: -24px;

      &::after {
        content: '';
        background-color: $thd-black;
        clip-path: polygon(100% 0, 100% 100%, 0 50%);
        height: 20px;
        width: 10px;
        position: absolute;
        right: -20px;
      }
    }
  }
}
</style>
